import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgEye = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 23 23",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M11.2651 9.09441C13.2902 9.09441 14.9318 10.736 14.9318 12.7611C14.9318 14.7861 13.2902 16.4277 11.2651 16.4277C9.2401 16.4277 7.59848 14.7861 7.59848 12.7611C7.59848 10.736 9.2401 9.09441 11.2651 9.09441ZM11.2651 10.4694C9.99949 10.4694 8.97348 11.4954 8.97348 12.7611C8.97348 14.0267 9.99949 15.0527 11.2651 15.0527C12.5308 15.0527 13.5568 14.0267 13.5568 12.7611C13.5568 11.4954 12.5308 10.4694 11.2651 10.4694ZM11.2651 5.88184C15.4942 5.88184 19.1449 8.76934 20.1578 12.8159C20.25 13.1842 20.0262 13.5575 19.6579 13.6497C19.2895 13.7419 18.9162 13.5181 18.824 13.1498C17.9633 9.71163 14.8597 7.25684 11.2651 7.25684C7.669 7.25684 4.5644 9.71375 3.70526 13.1539C3.61326 13.5223 3.24005 13.7463 2.87167 13.6543C2.50329 13.5623 2.27924 13.1891 2.37123 12.8207C3.3824 8.77183 7.03425 5.88184 11.2651 5.88184Z",
		fill: "currentColor"
	})
});
const ForwardRef = forwardRef(SvgEye);
export default ForwardRef;
